import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'

type PropsType = {
  color?: string
  size?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    color: { default: 'color-dark3' },
    size: { default: '40px' }
  },
  setup(__props: any) {

const props = __props as { color: string, size: string };



const style = computed<{ [key: string]: string }>(() => ({
  width: props.size,
  height: props.size,
  color: props.color,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["spinner", __props.color]),
    style: _normalizeStyle(_unref(style))
  }, null, 6))
}
}

})